import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { Form } from "antd";
import { InputField } from "../../../../../../../CommonComponents/commonStyles";
import { ErrorMesage } from "../../ContributionType/styles";
import {
  WrapLabel,
  LabelWrapper,
  InputWrapper,
  InputWrapperGraded
} from "./styles";
import { Rules } from "../Rules/Rules";
import Zipcode from "./Zipcode";
import { changeAddressValue, updateContributionStatus, updateErrorMessage, updateZipCodeValues, updateZipCodeErrorMessage } from "../../../actions";

export class AddressInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = { currentValue: this.props.value };
  }
  componentDidUpdate(nextProps) {
    this.rerunValidations(nextProps);
  }

  componentWillReceiveProps(nextProps) {
    let id =
      this.props.assetHeld +
      this.props.donorId +
      this.props.key +
      this.props.property;
    if (
      this.props.donorId &&
      this.props.assetHeld === nextProps.showErrorMessage.assetHeld &&
      nextProps.showErrorMessage.addressInput
    ) {
      let value = {};
      value[id] = this.props.value;
      this.props.form.setFieldsValue(value);
      this.props.form.validateFields();
      if (
        this.props.accountId === this.props.giftLength &&
        ((this.props.countryValue === "United States" && this.props.property === "city") || (this.props.countryValue !== "United States" && this.props.property === "state"))
      ) {
        if (
          !(
            ["assetHeldatVG", "assetOutsideVG"].includes(
              this.props.assetHeld
            ) &&
            this.props.contributionType === "mutualFund" &&
            this.props.isSecuritySelected
          )
        )
          this.props.updateErrorMessages({ type: "addressInput" });
      }
      if (
        this.props.accountId + 1 === this.props.giftLength &&
        this.props.property === "city"
      ) {
        if (
          this.props.accountInfo[this.props.accountId + 1]["type"] ===
          "Select Account Type"
        ) {
          if (
            !(
              ["assetHeldatVG", "assetOutsideVG"].includes(
                this.props.assetHeld
              ) &&
              this.props.contributionType === "mutualFund" &&
              this.props.isSecuritySelected
            )
          )
            this.props.updateErrorMessages({ type: "addressInput" });
        }
      }
    }
    if (nextProps.value !== this.props.value) {
      let values = {};
      values[id] = nextProps.value;
      this.props.form.setFieldsValue(values);
      if (
        (this.props.value !== "" &&
          nextProps.value &&
          this.props.countryValue === "United States") ||
        this.props.countryValue !== "United States"
      )
        this.props.form.validateFields();
      this.setState({ currentValue: nextProps.value });
    }
  }

  rerunValidations(nextProps) {
    if (nextProps.value !== this.props.value) {
      if (this.props.isSameAddress) {
        let id =
          this.props.assetHeld +
          this.props.donorId +
          this.props.key +
          this.props.property;
        let value = {};
        value[id] = this.props.value;
        this.props.form.setFieldsValue(value);
        this.props.form.validateFields();
      }
      if (this.props.property === "country") {
        if (nextProps.value !== this.props.value) {
          let value = {};
          let zipCodeId = this.props.key + "zipCode";
          value[zipCodeId] = this.props.zipCodeValue;
          this.props.form.setFieldsValue(value);
          this.props.form.validateFields();
        }
      }
    }
  }

  onTextChange = (e, regex) => {
    let updatedValue = e.target.value.replace(/\s{2,}/g, " ").replace(". ", "");
    if (updatedValue.length === 1) {
      updatedValue = updatedValue.replace(/\s{1,}/g, "");
    }
    if (regex.test(updatedValue)) {
      if (this.props.donorId > 0) {
        this.setState({ currentValue: updatedValue });
      }
      this.props.updateContributionStatus();
    }
  };

  onzipCodeChange = e => {
    let value = e.target.value.replace(/\s{2,}/g, " ").replace(". ", "");
    if (value.length === 1) {
      value = value.replace(" ", "");
    }
    if (this.props.countryValue === "United States") {
      const regex = /^[0-9-]{0,20}$/;
      if (regex.test(value)) {
        this.setState({ currentValue: value });
        this.props.updateContributionStatus();
      }
    } else {
      const regex = /^.{0,20}$/;
      if (regex.test(value)) {
        this.setState({ currentValue: value });
      }
    }
  };

  onZipCodeBlur = e => {
    if (
      this.props.property === "zipCode" &&
      this.props.countryValue === "United States"
    ) {
      const regex = /^([0-9]{5}\-[0-9]{4})$|^([0-9]{5})$/;
      if (regex.test(e.target.value) && this.props.donorId > 0) {
      }
    } else {
      this.props.form.validateFields();
    }
    e.target.value !== this.props.value &&
      this.props.updateAddress(e.target.value);
  };

  zipCodeRules = {
    usRules: [
      {
        required: true,
        message: <ErrorMesage> Please enter zip code.</ErrorMesage>
      },
      {
        pattern: /^([0-9]{5}\-[0-9]{4})$|^([0-9]{5})$/,
        message: (
          <ErrorMesage>
            {" "}
            The zip code must be in one of the following two formats: xxxxx or
            xxxxx-xxxx. Please correct to continue.{" "}
          </ErrorMesage>
        )
      }
    ],
    nonUS: [
      {
        required: true,
        message: <ErrorMesage>Please enter zip code.</ErrorMesage>
      }
    ]
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    let placeHolder = "Enter " + this.props.label.toLowerCase();
    const addressPath = {
      accountId: this.props.accountId,
      contributionType: this.props.contributionType,
      assetHeld: this.props.assetHeld,
      donorId: this.props.donorId
    };
    const inputId =
      this.props.assetHeld +
      this.props.donorId +
      this.props.key +
      this.props.property +
      "id";
    return (
      <WrapLabel>
        <InputWrapper>
          <Form.Item
            colon={false}
            label={<LabelWrapper>{this.props.label}</LabelWrapper>}
          >
            {getFieldDecorator(
              this.props.assetHeld +
                this.props.donorId +
                this.props.key +
                this.props.property,
              {
                validateTrigger: "onBlur",
                rules:
                  this.props.property === "zipCode"
                    ? this.props.countryValue === "United States"
                      ? this.zipCodeRules.usRules
                      : this.zipCodeRules.nonUS
                    : Rules[this.props.property].rules
              }
            )(
              this.props.donorId === 0 ? (
                <InputWrapperGraded>
                  <InputWrapper>
                    <div id={inputId}>
                      <InputField
                        id={"txt" + inputId}
                        aria-labelledby={this.props.property}
                        role="textbox"
                        placeholder={placeHolder}
                        disabled
                        value={this.props.loggedInValue}
                        getPopupContainer={() =>
                          document.getElementById(inputId)
                        }
                        className="macInputFieldPadding"
                      />
                    </div>
                  </InputWrapper>
                </InputWrapperGraded>
              ) : (
                <InputWrapper>
                  {this.props.property === "zipCode" ? (
                    <Zipcode
                      id={"txtZipcode" + inputId}
                      isUS={this.props.countryValue === "United States"}
                      name="zipcode"
                      aria-labelledby="zipcode"
                      role="textbox"
                      placeholder="Enter Zipcode"
                      title={`mac-Zipcode-${this.props.assetHeld +
                        "-" +
                        this.props.contributionType +
                        "-" +
                        this.props.accountId +
                        "-" +
                        this.props.donorId}`}
                      maxLength={
                        this.props.countryValue === "United States" && "20"
                      }
                      onBlur={e => this.onZipCodeBlur(e)}
                      onChange={e => this.onzipCodeChange(e)}
                      value={this.state.currentValue}
                      path={addressPath}
                    />
                  ) : (
                    <InputField
                      id={this.props.id}
                      placeholder={placeHolder}
                      role="textbox"
                      aria-labelledby={this.props.property}
                      value={this.state.currentValue}
                      className="macInputFieldPadding"
                      onChange={
                        this.props.property === "zipCode"
                          ? e => this.onzipCodeChange(e)
                          : e =>
                              this.onTextChange(
                                e,
                                Rules[this.props.property]
                                  ? Rules[this.props.property].onchangePattern
                                  : /^.*$/
                              )
                      }
                      onBlur={e => this.onZipCodeBlur(e)}
                    />
                  )}
                </InputWrapper>
              )
            )}
          </Form.Item>
        </InputWrapper>
      </WrapLabel>
    );
  }
}

const WrappedaddressInput = Form.create({ name: "selectAddressComponent" })(
  AddressInput
);

WrappedaddressInput.propTypes = {
  value: PropTypes.string,
  countryValue: PropTypes.string,
  isSameAddress: PropTypes.bool,
  zipCodeValue: PropTypes.string,
  isTouched: PropTypes.bool,
  zipCodeApiValue: PropTypes.object,
  accountInfo: PropTypes.string,
  showErrorMessage: PropTypes.object,
  isDummyUpdated: PropTypes.bool,
  isSecuritySelected: PropTypes.string,
  loggedInValue: PropTypes.string,
  updateAddress: PropTypes.func,
updateZipValues: PropTypes.func,
updateContributionStatus: PropTypes.func,
updateErrorMessages: PropTypes.func,
updateZipCodeErrorMessage: PropTypes.func,

}

const mapStateToProps = (state, ownProps) => ({
  value: state.getIn([
    "makeAContribution",
    "contributionTypes",
    `${ownProps.assetHeld}`,
    `${ownProps.contributionType}`,
    `${ownProps.accountId}`,
    "Donors",
    `${ownProps.donorId}`,
    "Address",
    `${ownProps.property}`
  ]),
  countryValue: state.getIn([
    "makeAContribution",
    "contributionTypes",
    `${ownProps.assetHeld}`,
    `${ownProps.contributionType}`,
    `${ownProps.accountId}`,
    "Donors",
    `${ownProps.donorId}`,
    "Address",
    "country"
  ]),
  isSameAddress: state.getIn([
    "makeAContribution",
    "contributionTypes",
    `${ownProps.assetHeld}`,
    `${ownProps.contributionType}`,
    `${ownProps.accountId}`,
    "Donors",
    `${ownProps.donorId}`,
    "isSameAddress"
  ]),
  zipCodeValue: state.getIn([
    "makeAContribution",
    "contributionTypes",
    `${ownProps.assetHeld}`,
    `${ownProps.contributionType}`,
    `${ownProps.accountId}`,
    "Donors",
    `${ownProps.donorId}`,
    "Address",
    "zipCode"
  ]),
  isTouched: state.getIn([
    "makeAContribution",
    "contributionTypes",
    `${ownProps.assetHeld}`,
    `${ownProps.contributionType}`,
    `${ownProps.accountId}`,
    "Donors",
    `${ownProps.donorId}`,
    "Address",
    "isTouched"
  ]),
  zipCodeApiValue: state.getIn(["zipCode", "zipCodes"]).toJS(),
  accountInfo: state.getIn([
    "makeAContribution",
    "contributionTypes",
    `${ownProps.assetHeld}`,
    `${ownProps.contributionType}`
  ]),
  showErrorMessage: state.getIn([
    "makeAContribution",
    "contributionTypes",
    "showErrorMessage"
  ]),
  isDummyUpdated: state.getIn([
    "makeAContribution",
    "contributionTypes",
    "dummyUpdate"
  ]),
  isSecuritySelected: state.getIn([
    "makeAContribution",
    "contributionTypes",
    `${ownProps.assetHeld}`,
    "sgSelected"
  ]),
  loggedInValue: state.getIn([
    "makeAContribution",
    "apiData",
    "loggedInAddress",
    "data",
    "Address",
    `${ownProps.property}`
  ])
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateAddress: e =>
    dispatch(
      changeAddressValue({
        value: e,
        property: ownProps.property,
        accountId: ownProps.accountId,
        contributionType: ownProps.contributionType,
        assetHeld: ownProps.assetHeld,
        donorId: ownProps.donorId
      })
    ),
  updateZipValues: e =>
    dispatch(
      updateZipCodeValues({
        value: e,
        accountId: ownProps.accountId,
        contributionType: ownProps.contributionType,
        assetHeld: ownProps.assetHeld,
        donorId: ownProps.donorId,
        uniqueId: `PrimaryZipcode${ownProps.assetHeld +
          ownProps.contributionType +
          ownProps.accountId +
          ownProps.donorId}`
      })
    ),
  updateContributionStatus: () =>
    dispatch(
      updateContributionStatus({ value: false, assetHeld: ownProps.assetHeld })
    ),
  updateErrorMessages: data => dispatch(updateErrorMessage(data)),
  updateZipCodeErrorMessage: data => dispatch(updateZipCodeErrorMessage(data))
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WrappedaddressInput)
);
